module.exports = __webpack_public_path__ + "media/images/hero_images/security-400-e3c360dac51b4aa733bad493066a4a36.png";